import NavBarAdmin from "../../components/Admin/Layout/NavBarAdmin";
import { useEffect } from "react";
import { useCategoriesServicesStore } from "../../stores/admin/categoriesServices";
import pen from "../../assets/icons/edit.svg";
import trash from "../../assets/icons/trash.svg";
import {
  getCategoriesMissions,
  patchCategoryRequeteDefault,
  renewableMission,
} from "../../services/Api/adminService";
import { useParams } from "react-router-dom";
import {
  createCategoryDocRequestByIdPartner,
  createCategoryMissionByIdPartner,
  deleteCategoryDocRequestByIdPartner,
  deleteCategoryMissionByIdPartner,
  getCategoriesDocRequestByIdPartner,
  updateCategoryDocRequestByIdPartner,
  updateCategoryMissionByIdPartner,
} from "../../services/Api/partnerService";
import { showToastError } from "../../services/Toasts/toasts";
import { ToastContainer } from "react-toastify";
import useTooltip from "../../hooks/useTooltip";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";

const AdminCategories = () => {
  const {
    services,
    setServices,
    newService,
    setNewService,
    updateService,
    setUpdateService,
    idService,
    setIdService,
    categories,
    setCategories,
    newCategory,
    setNewCategory,
    editingServiceId,
    setEditingServiceId,
    modifyNameCategory,
    setModifyNameCategory,
    modifyNameService,
    setModifyNameService,
    setIdCategory,
    editingCategoryId,
    setEditingCategoryId,
  } = useCategoriesServicesStore();
  const { idPartner } = useParams();
  // Hook
  const [tooltipState, handleMouseEnter, handleMouseLeave] = useTooltip();

  useEffect(() => {
    getCategoriesMissions(Number(idPartner))
      .then((data) => setServices(data))
    .catch(() => showToastError("Une erreur s'est produite"));


    if (idService !== 0) {
      getCategoriesDocRequestByIdPartner(Number(idPartner), idService)
        .then((data) => setCategories(data))
      .catch(() => showToastError("Une erreur s'est produite"));

    }
  }, [updateService, idService]);

  // This is for services
  const handleCreateService = () => {
    const data = {
      name: newService,
    };

    createCategoryMissionByIdPartner(Number(idPartner), data)
      .then(() => {
        setUpdateService(!updateService);
        setNewService("");
      })
    .catch(() => showToastError("Une erreur s'est produite"));

  };

  const handleDeleteService = (idService: number) => {
    deleteCategoryMissionByIdPartner(Number(idPartner), Number(idService))
      .then(() => {
        setUpdateService(!updateService)
        setIdService(0)
        setCategories([])
      })
      .catch(() => {
        showToastError(
          "Vous ne pouvez pas supprimer un service qui est lié à des missions en cours."
        );
      });
  };

  const handleupdateServiceName = (idService: number) => {
    const data = {
      name: modifyNameService,
    };

    updateCategoryMissionByIdPartner(Number(idPartner), idService, data)
      .then(() => {
        setUpdateService(!updateService);
        setEditingServiceId(null);
        setModifyNameService("");
      })
    .catch(() => showToastError("Une erreur s'est produite"));

  };

  // This is for categories
  const handleCreateCategory = () => {
    const data = {
      name: newCategory,
      CategoryMissionId: idService,
    };
    if (idService === 0 || idService === undefined)
      return showToastError(
        "Veuillez selectionner un service avant de créer une catégorie."
      );
    createCategoryDocRequestByIdPartner(Number(idPartner), data)
      .then(() => {
        setUpdateService(!updateService);
        setNewCategory("");
      })
    .catch(() => showToastError("Une erreur s'est produite"));

  };

  const handleDeleteCategory = (idCategory: number) => {
    deleteCategoryDocRequestByIdPartner(Number(idPartner), idCategory)
      .then(() => {
        setUpdateService(!updateService);
      })
      .catch(() => {
        showToastError(
          "Vous ne pouvez pas supprimer une catégorie qui est lié à des requêtes en cours."
        );
      });
  };

  const handleUpdateCategory = (idCategory: number) => {
    const data = {
      name: modifyNameCategory,
    };
    updateCategoryDocRequestByIdPartner(Number(idPartner), idCategory, data)
      .then(() => {
        setUpdateService(!updateService);
        setEditingCategoryId(null);
        setModifyNameCategory("");
      })
    .catch(() => showToastError("Une erreur s'est produite"));

  };

  const handleRenewable = (idCategory: number, checked: boolean) => {
    const data = {
      renewable: checked,
    };
    renewableMission(Number(idPartner), idCategory, data)
      .then(() => {
        setUpdateService(!updateService);
      })
    .catch(() => showToastError("Une erreur s'est produite"));

  };

  const handleDefault = (idCategory: number, checked: boolean) => {
    const data = {
      isDefault: checked,
    };
    patchCategoryRequeteDefault(Number(idPartner), idService, idCategory, data)
      .then(() => {
        setUpdateService(!updateService);
      })
    .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start">
        <NavBarAdmin />
        <ToastContainer position="top-center" />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <svg className="w-6 h-6 text-grey-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Configuration des services et catégories <span className="text-yellow-trio">({services?.length || 0} services)</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez vos services et leurs catégories associées
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section principale avec 2 colonnes côte à côte */}
          <div className="flex flex-col lg:flex-row w-11/12 h-[80%] gap-6">
            {/* Colonne Services */}
            <div className="w-full lg:w-1/2 bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-700">Services</h2>
                  <p className="text-gray-600 text-sm">Créez et gérez vos services</p>
                </div>
              </div>

              {/* Formulaire de création de service */}
              <div className="flex items-center gap-3 mb-6">
                <input
                  type="text"
                  name="service"
                  id="service"
                  placeholder="Nom du service"
                  value={newService}
                  onChange={(e) => setNewService(e.target.value)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                />
                <button
                  onClick={() => handleCreateService()}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Créer
                </button>
              </div>

              {/* Liste des services */}
              <div className="h-[80%] overflow-y-auto">
                {services?.map((service: any) => (
                  <div
                    key={service.id}
                    className={`w-full p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
                      service.id === idService 
                        ? "bg-blue-50 border-blue-200 shadow-md" 
                        : "bg-gray-50 border-gray-200 hover:bg-gray-100"
                    } mb-2`}
                    onClick={() => setIdService(service.id)}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        {editingServiceId === service.id ? (
                          <input
                            type="text"
                            name="service"
                            id="service"
                            placeholder={service.name}
                            value={modifyNameService}
                            onChange={(e) => setModifyNameService(e.target.value)}
                            className="px-3 py-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            onClick={(e) => e.stopPropagation()}
                          />
                        ) : (
                          <span className="text-left font-medium text-gray-700">
                            {service.name}
                          </span>
                        )}
                      </div>
                      
                      <div className="flex items-center gap-2">
                        {/* Checkbox renewable */}
                        <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            name="renewable"
                            id={`renewable-${service.id}`}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                            checked={service?.isRenewable}
                            onChange={(e) => handleRenewable(service.id, e.target.checked)}
                            onMouseEnter={(e) => handleMouseEnter("Mission reconductible", e)}
                            onMouseLeave={handleMouseLeave}
                            disabled={service?.isUsed}
                          />
                          <label htmlFor={`renewable-${service.id}`} className="text-xs text-gray-600">
                            Renouvelable
                          </label>
                        </div>
                        
                        {/* Boutons d'action */}
                        {editingServiceId === service.id ? (
                          <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                            <button
                              className="p-1 text-green-600 hover:bg-green-100 rounded transition-colors duration-200"
                              onClick={() => handleupdateServiceName(service.id)}
                              title="Confirmer"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            </button>
                            <button
                              className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors duration-200"
                              onClick={() => {
                                setModifyNameService("");
                                setEditingServiceId(null);
                              }}
                              title="Annuler"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                            <button
                              className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                              onClick={() => setEditingServiceId(service.id)}
                              title="Modifier"
                            >
                              <img src={pen} alt="Modifier" className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteService(service.id)}
                              className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-colors duration-200"
                              title="Supprimer"
                            >
                              <img src={trash} alt="Supprimer" className="w-4 h-4" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Colonne Catégories */}
            <div className="w-full lg:w-1/2 bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-green-100 rounded-lg">
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-700">Catégories</h2>
                  <p className="text-gray-600 text-sm">
                    {idService !== 0 ? `Catégories pour le service sélectionné` : "Sélectionnez un service pour voir ses catégories"}
                  </p>
                </div>
              </div>
              
              {/* Formulaire de création de catégorie */}
              {idService !== 0 && (
                <div className="flex items-center gap-3 mb-6">
                  <input
                    type="text"
                    name="category"
                    id="category"
                    value={newCategory}
                    placeholder="Nom de la catégorie"
                    onChange={(e) => setNewCategory(e.target.value)}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                  />
                  <button
                    onClick={() => handleCreateCategory()}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center gap-2"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    Créer
                  </button>
                </div>
              )}

              {/* Liste des catégories */}
              <div className="h-[80%] overflow-y-auto">
                {categories?.map((category: any) => (
                  <div
                    key={category.id}
                    className="w-full p-3 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-all duration-200 mb-2"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        {editingCategoryId === category.id ? (
                          <input
                            type="text"
                            name="category"
                            id="category"
                            placeholder={category.name}
                            value={modifyNameCategory}
                            onChange={(e) => setModifyNameCategory(e.target.value)}
                            className="px-3 py-1 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                          />
                        ) : (
                          <button
                            className="text-left font-medium text-gray-700 hover:text-green-600 transition-colors duration-200"
                            onClick={() => setIdCategory(category.id)}
                          >
                            {category.name}
                          </button>
                        )}
                      </div>
                      
                      {/* Boutons d'action */}
                      {editingCategoryId === category.id ? (
                        <div className="flex items-center gap-1">
                          <button
                            className="p-1 text-green-600 hover:bg-green-100 rounded transition-colors duration-200"
                            onClick={() => handleUpdateCategory(category.id)}
                            title="Confirmer"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          </button>
                          <button
                            className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors duration-200"
                            onClick={() => {
                              setModifyNameCategory("");
                              setEditingCategoryId(null);
                            }}
                            title="Annuler"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-1">
                          <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            name="default"
                            id={`default-${category.id}`}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                            checked={category?.isDefault}
                            onChange={(e) => handleDefault(category.id, e.target.checked)}
                            onMouseEnter={(e) => handleMouseEnter("Catégorie par défaut", e)}
                            onMouseLeave={handleMouseLeave}
                            disabled={category?.isUsed}
                          />
                          <label htmlFor={`default-${category.id}`} className="text-xs text-gray-600">
                            Par default
                          </label>
                        </div>
                          <button
                            className="p-2 text-green-600 hover:bg-green-100 rounded-lg transition-colors duration-200"
                            onClick={() => setEditingCategoryId(category.id)}
                            title="Modifier"
                          >
                            <img src={pen} alt="Modifier" className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDeleteCategory(category.id)}
                            className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-colors duration-200"
                            title="Supprimer"
                          >
                            <img src={trash} alt="Supprimer" className="w-4 h-4" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                
                {(!categories || categories.length === 0) && idService !== 0 && (
                  <div className="text-center py-8 text-gray-500">
                    <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                    </svg>
                    <p>Aucune catégorie trouvée pour ce service</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Tooltip */}
          {tooltipState.content && (
            <div
              className="bg-gray-800 text-white p-2 rounded-lg text-sm absolute z-50 w-auto max-w-[200px] shadow-lg"
              style={{
                top: tooltipState.position.y,
                left: tooltipState.position.x,
              }}
            >
              {tooltipState.content}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminCategories;
